import { FC } from "react";

import { CHEVRON_LEFT_ICON_PATHS } from "mds/utils/icon-paths";
import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ChevronLeftIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path d={CHEVRON_LEFT_ICON_PATHS[0]} fill="currentColor" />
  </svg>
);
